import React from 'react';
import { Card, Table, Alert, Badge } from 'react-bootstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan, faPlus, faGift } from '@fortawesome/free-solid-svg-icons';
import HDBonusService from '../../services/hd.bonus.service';
import { hideLoading, showLoading } from '../../lib/uiService';
import { toast } from 'react-toastify';

interface HDBonusTableProps {
  isAdmin?: boolean; // If true, show all users' submissions
  bonusHistory: any[]; // Array of bonus history records
}

const HDBonusTable: React.FC<HDBonusTableProps> = ({ isAdmin = false, bonusHistory }) => {
  const onDeleteBonus = async (id: string) => {
    // Handle delete bonus logic here
    showLoading();
    try {
      await HDBonusService.DeleteHDBonus(id);
      hideLoading();
      await toast.success('Successfully Deleted Bonuses');
      window.location.reload();
    } catch (error) {
      hideLoading();
      console.log(error);
    }
  };

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Date Submitted</th>
          <th>Bonus Period</th>
          <th>Health</th>
          <th>Development</th>
          <th>Book Read</th>
          {isAdmin && <th>User</th>}
          {isAdmin && <th>Action</th>}
        </tr>
      </thead>
      <tbody>
        {bonusHistory.map((bonus) => (
          <tr key={bonus.submissionId}>
            <td>
              <a href={`/hd-bonus/${bonus.submissionId}`} rel="noopener noreferrer">
                {moment(bonus.createdAt).format('MMM D, YYYY')}
              </a>
            </td>
            <td>{moment(`${bonus.year}-${bonus.month}-01`).format('MMMM YYYY')}</td>
            <td>{bonus.healthBonusAmount > 0 ? <Badge bg="success">Yes</Badge> : <Badge bg="secondary">No</Badge>}</td>
            <td>
              {bonus.developmentBonusAmount > 0 ? <Badge bg="success">Yes</Badge> : <Badge bg="secondary">No</Badge>}
            </td>
            <td>{bonus.answers?.find((a) => a.questionId === 3)?.textValue || 'N/A'}</td>
            {isAdmin && (
              <td>
                {bonus.user
                  ? `${[bonus.user.firstName, bonus.user.lastName].filter(Boolean).join(' ')}`
                  : 'Unknown User'}
              </td>
            )}
            {isAdmin && (
              <td>
                <button
                  className="btn btn-danger btn-sm"
                  type="button"
                  onClick={() => onDeleteBonus(bonus.submissionId)}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default HDBonusTable;
